import React from 'react';

import { withTranslation } from 'lib/i18n';

import { QuoteProps } from './types';
import QuoteWrap from './styled/QuoteWrap';

const Quote: React.FC<QuoteProps> = props => {
  const text = props.t(`${props.base}.text`);
  const name = props.t(`${props.base}.name`);
  const job = props.t(`${props.base}.job`);

  return (
    <QuoteWrap>
      <q>{text}</q>
      <small>
        &mdash; <strong>{name}</strong> {job}
      </small>
    </QuoteWrap>
  );
};

export default withTranslation('pages')(Quote);
